import React from 'react'

import get from 'lodash/get'

import { getWheelData } from '../../resumesearch/dataTransformation'
import { useQuery } from '../hooks/useQuery'

const withSearch360EducationProfiles = BaseComponent => props => {
  const operation = 'educationPaths'
  const defaultVariables = {
    exactMatch: { value: true, required: true },
    majors: {
      value: [],
      required: true,
      list: true,
      name: 'majors',
      type: 'String',
    },
    universities: {
      type: 'String',
      value: [],
      list: true,
      name: 'universities',
    },
  }

  const { data, refetch, error, loading, setData } = useQuery(operation, defaultVariables, {
    lazy: true,
  })

  const getCareersData = async searchFormValues => {
    const { exact_match, university, search_query } = searchFormValues
    if (!search_query) return

    const universities = university ? { universities: [university] } : {}

    let variables = {
      majors: [search_query],
      exactMatch: exact_match ? exact_match : true,
      ...universities,
    }

    refetch(variables)
  }

  const careerPaths = get(data, 'results.careerPathData', [])

  const careerPathsWheelData = getWheelData(careerPaths)

  return (
    <BaseComponent
      {...props}
      careerPaths={careerPaths}
      getCareerPaths={getCareersData}
      loadingCareersData={loading}
      searchError={error}
      setCareersData={setData}
      careerPathsWheelData={careerPathsWheelData}
    />
  )
}

export default withSearch360EducationProfiles



// WEBPACK FOOTER //
// ./src/utils/graphql/hocs/withSearch360EducationProfiles.js